import { getCampaignOmaLummePrices } from '../actions';
import { deliveryIsGreen, deliveryIsVaihtoturva } from '../components/Contracts/ContractDetails';
import { CustomerAddress, InputAddress, MeteringPointAddress } from '../types/address';
import { ContractManagementForm, ContractManagementFrendsAddress, Delivery, OmaLummeCampaign } from '../types/contract';
import { PriceFixTariffNo } from './contracts';

export async function fetchCampaignOmaLummePrices(campaign?: string): Promise<OmaLummeCampaign[]> {
  if (campaign) {
    const prices = await getCampaignOmaLummePrices(parseInt(campaign));

    if (prices && prices.length > 0) {
      return prices;
    }
  }
  return [];
}

export function checkHouseType(type: string, templateName: string): boolean {
  if (
    (type === 'flat' && templateName.includes('kerrostalo')) ||
    (type === 'row' && templateName.includes('rivitalo')) ||
    (type === 'detached' && templateName.includes('ok-talo') && !templateName.includes('ok-talo sähkö')) ||
    (type === 'detached-electric-heating' && templateName.includes('ok-talo sähkö')) ||
    (type === 'cottage' && templateName.includes('rivitalo'))
  ) {
    return true;
  }
  return false;
}

export function validateContractManagementForm(form: ContractManagementForm): void {
  const {
    selectedForm,
    selectedForm2,
    selectedForm4,
    oldContract,
    endDate,
    startDate,
    createNewContract,
    newAddress,
    primaryAddressValid,
    terminateAddressValid,
    newContract,
    extraServices,
    paymentTypeValid,
    paymentTypeEbillValid,
    paymentTypeNewEmailValid,
    termsAccepted,
    setFormValid,
  } = form;
  if (selectedForm === 1 && oldContract && endDate && !createNewContract && terminateAddressValid && primaryAddressValid) {
    setFormValid(true);
  } else if (
    selectedForm === 1 &&
    oldContract &&
    endDate &&
    createNewContract &&
    newAddress &&
    startDate &&
    newContract &&
    paymentTypeValid &&
    paymentTypeEbillValid &&
    paymentTypeNewEmailValid &&
    termsAccepted
  ) {
    setFormValid(true);
  } else if (
    selectedForm === 2 &&
    selectedForm2 !== 0 &&
    newAddress &&
    startDate &&
    newContract &&
    paymentTypeValid &&
    paymentTypeEbillValid &&
    paymentTypeNewEmailValid &&
    termsAccepted
  ) {
    setFormValid(true);
  } else if (selectedForm === 3 && oldContract && endDate && terminateAddressValid) {
    setFormValid(true);
  } else if (
    selectedForm === 4 &&
    selectedForm4 === 1 &&
    oldContract &&
    startDate &&
    newContract &&
    paymentTypeValid &&
    paymentTypeEbillValid &&
    paymentTypeNewEmailValid &&
    termsAccepted
  ) {
    setFormValid(true);
  } else if (
    selectedForm === 4 &&
    selectedForm4 === 2 &&
    oldContract &&
    paymentTypeValid &&
    paymentTypeEbillValid &&
    paymentTypeNewEmailValid &&
    termsAccepted
  ) {
    setFormValid(true);
  } else if (selectedForm === 4 && selectedForm4 === 3 && oldContract && extraServices.length > 0 && termsAccepted) {
    setFormValid(true);
  } else {
    setFormValid(false);
  }
}

export function validateAddress(address: CustomerAddress | InputAddress | MeteringPointAddress | ContractManagementFrendsAddress): boolean {
  if (address.streetName && address.zipCode && address.cityName) {
    return true;
  } else {
    return false;
  }
}

export function removeTags(html: string): string {
  html = html.replace(/<br\/>/g, '$br$');
  html = html.replace(/(?:\r\n|\r|\n)/g, '$br$');
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  html = tmp.textContent || tmp.innerText;
  html = html.replace(/\$br\$/g, '\n');
  return html;
}

export const tariffsUpgradableToGreenEnergy = [16, 23, 1, 7, 35, 5, 4, 3, 29, 144, 130, 148, PriceFixTariffNo];

export const extraServicesAvailable = (deliveries: Delivery[]) => {
  return deliveries.find(
    (d) =>
      /* TODO in LE-262 (canceling extra services)
    d.elementName.toLowerCase().includes('vaihtoturva') || */
      tariffsUpgradableToGreenEnergy.includes(d.tariffNo) &&
      deliveries.filter((delivery) => delivery.contrctGroup === 1 && deliveryIsGreen(delivery)).length === 0,
  );
};
export const existingExtraServices = (deliveries: Delivery[]) => {
  return deliveries.filter((d) => (d.contrctGroup === 1 && deliveryIsVaihtoturva(d)) || (d.contrctGroup === 1 && deliveryIsGreen(d)));
};

export const selectedFormToUseCase = (
  selectedForm: number,
  selectedForm2: number,
  selectedForm4: number,
  createNewContract: boolean | undefined,
  continueWithOldContract: boolean,
) => {
  if (selectedForm === 2 && selectedForm2 === 1) {
    return 'moveIn';
  }
  if (selectedForm === 1 && createNewContract && !continueWithOldContract) {
    return 'moveOut';
  }
  if (selectedForm === 1 && createNewContract && continueWithOldContract) {
    return 'moveTransfer';
  }
  if (selectedForm === 2 && selectedForm2 === 2) {
    return 'new';
  }
  if ((selectedForm === 1 && !createNewContract) || selectedForm === 3) {
    return 'terminate';
  }
  if (selectedForm === 4 && selectedForm4 === 1) {
    return 'productChange';
  }
  if (selectedForm === 4 && selectedForm4 === 3) {
    return 'addonproducts';
  }
  return 'new';
};

export const paymentTypeToNumber = (paymentType: string) => {
  switch (paymentType) {
    case 'paperMyAddress':
      return 1;
      break;
    case 'paperNewAddress':
      return 1;
      break;
    case 'eBill':
      return 3;
      break;
    case 'emailMyAddress':
      return 8;
      break;
    case 'emailNewAddress':
      return 8;
      break;
    default:
      return 1;
      break;
  }
};

export const bankNameToId = (bankName: string) => {
  switch (bankName) {
    case 'Aktia Pankki':
      return 11;
      break;
    case 'Danske Bank':
      return 16;
      break;
    case 'Handelsbanken':
      return 21;
      break;
    case 'Nordea':
      return 24;
      break;
    case 'Osuuspankki':
      return 25;
      break;
    case 'POP Pankki':
      return 26;
      break;
    case 'S-pankki':
      return 27;
      break;
    case 'Säästöpankki':
      return 31;
      break;
    case 'Ålandsbanken':
      return 32;
      break;
    default:
      return undefined;
      break;
  }
};

export const createContractManagementFrendsAddress = (
  address: CustomerAddress | InputAddress | MeteringPointAddress | ContractManagementFrendsAddress,
) => {
  if (address.streetName && address.zipCode && address.cityName) {
    return {
      streetName: address.streetName,
      houseNumber: address.houseNumber,
      houseLetter: address.houseLetter,
      residence: address.residence,
      zipCode: address.zipCode,
      cityName: address.cityName,
      careOf: address.careOf,
    };
  }
  return false;
};

export const SummaryActionTitle = (selectedForm: number, selectedForm4: number): string => {
  if (selectedForm === 1) {
    return 'manageContracts:manageContracts.StartOption1Title';
  }
  if (selectedForm === 2) {
    return 'manageContracts:manageContracts.StartOption2Title';
  }
  if (selectedForm === 3) {
    return 'manageContracts:manageContracts.StartOption3Title';
  }
  if (selectedForm === 4 && selectedForm4 !== 2) {
    return 'manageContracts:manageContracts.StartOption4Title';
  }
  if (selectedForm === 4 && selectedForm4 === 2) {
    return 'manageContracts:manageContracts.SummaryStartOption4TitlePaymentChange';
  }
  return '';
};
